import { useNavigate } from 'react-router-dom'
import Table from '../../components/Table'
import { useEffect, useState } from 'react'
import { customerService } from '../../services/customer.service'
import { VenueDto } from '@ivy-monorepo/shared'

const VenuesPage = () => {
  const navigate = useNavigate()
  const [venues, setVenues] = useState<VenueDto[]>([])

  useEffect(() => {
    const fetchVenues = async () => {
      const venues = await customerService.getVenues()
      setVenues(venues)
    }
    fetchVenues()
  }, [])
  return (
    <div>
      <div className="venues-container">
        <h2>Venues</h2>
        <Table
          id="venues"
          name="Venues"
          keyField="publicId"
          initialSortColumn="name"
          columns={[
            { label: '', accessor: 'logoUrl', type: 'venueAvatar' },
            { label: 'Name', accessor: 'name', type: 'nameAndAddress' },
            { label: 'Visits', accessor: 'visits', type: 'number' },
            { label: 'Created', accessor: 'createdAt', type: 'datetime' },
          ]}
          sourceData={venues || []}
          isPropertyBarVisible={false}
          filterTerms=""
          onRowClick={(row: VenueDto) => navigate(`/customer/venues/${row.publicId}`)}
        />
      </div>
    </div>
  )
}

export default VenuesPage
